/* eslint-disable import/no-anonymous-default-export */
import axios, { Axios, AxiosError } from "axios"
import useApi, { ActionResult, Api, Model, Query } from "../common/hooks/useApi"
import { Usuario } from "../usuarios/useUsuariosAPI"

export interface LoteConsulta extends Model {
    FechaHora: string
    NroLote: number
    Patentes: string[]
    CantidadPatentes: number
    CantidadInfracciones: number
    CantidadInfraccionesDescartadas: number
    CantidadInfraccionesConsultadas: number
    CantidadInfraccionesConsultando: number
    CantidadInfraccionesVerificadas: number
    UltimoVerificador?: Usuario
    UnidadesProdNombre?: string
    CategoriasCodigo?: string | null
}



const module = "LoteConsulta";
export default () => {
    const api = useApi({ module });

    return {
        list: (query: Query) => api.list!<LoteConsulta>(query),
        save: (data: Partial<LoteConsulta>) => api.save!<Partial<LoteConsulta>, LoteConsulta>(data),
        delete: (id: number) => api.delete!<LoteConsulta>(id),
        queryExistingTitulares: async (query: Query, antiguedadMaxTitularDias?: number, ongoingQuery?: boolean, unidadesProd?: string[]): Promise<ActionResult<LoteConsulta | null>> => {            
            try {
                const qs = api.queryToString(query);
                const unidadesProdNombresString = unidadesProd?.join(',');                
                const response = await api.axiosInstance.post<LoteConsulta>(`${module}/ConsultarTitularesExistentes?${qs}&antiguedadMaxTitularDias=${antiguedadMaxTitularDias}&reconsultarTitularesPendientes=${ongoingQuery ?? false}&unidadesProdNombres=${unidadesProdNombresString}`);

                return {
                    data: { value: response.data },
                };
            } catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        },
        queryTitulares: async (query: Query, ongoingQuery?: boolean,  unidadesProd?: string[] ): Promise<ActionResult<{ filename: string, blob: Blob}>> => {
            try {
                const qs = api.queryToString(query);
                const unidadesProdNombresString = unidadesProd?.join(',');

                const response = await api.axiosInstance.get<Blob>(`${module}/ConsultarTitulares?${qs}&reconsultarTitularesPendientes=${ongoingQuery ?? false}&unidadesProdNombres=${unidadesProdNombresString}`, {
                    responseType: 'blob'
                });

                return {
                    data: {
                        value: {
                            blob: response.data, filename:
                                response.headers["content-disposition"].match(/filename=(.*);/)![1]
                        }
                    }
                };
            } catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        },
        loadQueriedData: async (file: File, tipoProveedor : string) => {
            try {
                const formData = new FormData();
                formData.append("file", file);
                formData.append("tipoProveedor",tipoProveedor);

                await api.axiosInstance.post(`${module}/CargarConsulta`, formData);
                return {
                    data: { value: undefined },
                };
            } catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        },
        loadConsultaRevisada: async (file: File) => {
            try {
                const formData = new FormData();
                formData.append("file", file);

                await api.axiosInstance.patch(`${module}/CargarCsv`, formData);
                return {
                    data: { value: undefined },
                };

            } catch (error: any | AxiosError) {
                return {
                    error
                };
            }
        },
        queryCantidadLocalTitulares: async (query: Query, antiguedadMaxTitularDias?: number, ongoingQuery?: boolean) => {
            try {
                const qs = api.queryToString(query);
                const response = await api.axiosInstance.get<LoteConsulta>(`${module}/VerCantidadLocal?${qs}&antiguedadMaxTitularDias=${antiguedadMaxTitularDias}&reconsultarTitularesPendientes=${ongoingQuery ?? false}`);

                return {
                    data: { value: response.data },
                };
            } catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        },
        downloadCsv: async (query:Query) => {

            try {
                //const response = await api.axiosInstance.get<LoteConsulta>(`${module}/VerCantidadLocal?${qs}&antiguedadMaxTitularDias=${antiguedadMaxTitularDias}`);
                const qs = api.queryToString(query);
                window.location.href = `${api.baseAxiosConfig.baseURL}/${module}/DescargarCsv?${qs}&access_token=${localStorage.getItem("_token")}`;

            } catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        },
        queryProvedoresConsulta: async () => {
            try {
                const response = await api.axiosInstance.get(`ProveedorConsulta`);
                return {
                    data: response.data
                };
            } catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        },
        limpiarConsultando: async (NroLote: number, idRenombrador: number) => {
            try {                
                const response = await api.axiosInstance.patch(`${module}/Consultando/Limpiar?NroLote=${NroLote}&idRenombrador=${idRenombrador}`);
                return {
                    data: { value: response.data },
                };
            }
            catch(error: any | AxiosError) {                
                return { error };
            }
        },
        consultaExterna: async (loteConsultaId:number, proveedorExterno = 'insider') => {
            try {
                const response = await api.axiosInstance.post(`${module}/CargarConsulta/externa?nroLoteConsulta=${loteConsultaId}&proveedorExterno=${proveedorExterno}`)
            } catch (error) {
                console.log(error)   
            }
        }
    };
}